import UploadButton from './src/index'

UploadButton.install = function (Vue) {
  Vue.component(UploadButton.name, UploadButton)
}

export default UploadButton
